// /src/pages/admin/ProjectsListPage.tsx

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getProjects } from "../../lib/firebase/firestore";
import { Project } from "../../types";
import { deleteProject } from '../../lib/firebase/firestore';

export const ProjectsListPage = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProjects = async () => {
      try {
        const data = await getProjects();
        setProjects(data);
      } catch (error) {
        console.error("Failed to fetch projects:", error);
      } finally {
        setLoading(false);
      }
    };

    loadProjects();
  }, []);

  if (loading) return <div>Loading projects...</div>;

  return (
    <div>
      <h2>Projects</h2>
      <Link
        to="/admin/projects/new"
        style={{ marginBottom: "1rem", display: "inline-block" }}
      >
        ➕ Add New Project
      </Link>
      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
        {projects.map((project) => (
          <li
            key={project.id}
            style={{ borderBottom: "1px solid #eee", padding: "0.5rem 0" }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{project.title}</span>
              <div>
                <Link
                  to={`/admin/projects/edit/${project.id}`}
                  style={{ marginRight: "1rem" }}
                >
                  ✏️ Edit
                </Link>
                <button
                  onClick={async () => {
                    if (
                      window.confirm(
                        "Are you sure you want to delete this project?"
                      )
                    ) {
                      try {
                        await deleteProject(project.id);
                        alert("Project deleted successfully!");
                      } catch (error) {
                        console.error("Error deleting project:", error);
                        alert("Failed to delete project");
                      }
                    }
                  }}
                >
                  🗑️ Delete
                </button>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
